import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Captures ?aff= parameter from any page URL and stores it in a 30-day cookie.
 * This ensures affiliate credit persists even if the user leaves and returns later.
 */
const AffiliateCookieCatcher = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const aff = searchParams.get("aff");
    if (aff) {
      const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `bookr_aff=${encodeURIComponent(aff)}; path=/; expires=${expires}; SameSite=Lax`;
    }
  }, [searchParams]);

  return null;
};

export default AffiliateCookieCatcher;
